unit TemperatureType;

interface

type
  TTemperatureType = class
  private
    fTemperatureKey: String;
    fValue: Single;
    fActive: Boolean;
  public
    property TemperatureKey: String read fTemperatureKey;
    property Value: Single read fValue;
    property Active: Boolean read fActive;
    constructor Create(const String_TemperatureKey: String);
  end;

implementation

constructor TTemperatureType.Create(const String_TemperatureKey: String);
begin
  inherited Create();

  fTemperatureKey := String_TemperatureKey;
end;

end.
